import React from 'react';
import Layout from '../components/layout/Layout';
import { projects } from '../data/projects';

function ProjectCard({ project }) {
  return (
    <article className="border-b border-border py-12 md:py-16 first:pt-0 last:border-b-0">
      <div className="space-y-10">
        {/* Header */}
        <div className="flex items-baseline gap-4">
          <h2 className="text-heading font-mono">{project.title}</h2>
          <span className="text-small text-muted">— {project.category}</span>
        </div>

        {/* Problem State */}
        <div className="space-y-4">
          <h3 className="text-caption text-muted uppercase tracking-wider">
            Problem State
          </h3>
          <ul className="space-y-2">
            {project.problemState.map((item, index) => (
              <li key={index} className="text-body text-subtle">
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Constraints Imposed */}
        <div className="space-y-4">
          <h3 className="text-caption text-muted uppercase tracking-wider">
            Constraints Imposed
          </h3>
          <ul className="space-y-2">
            {project.constraintsImposed.map((item, index) => (
              <li key={index} className="flex items-start gap-3">
                <span className="text-muted text-small mt-1">→</span>
                <span className="text-body text-subtle">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Systems Deployed */}
        <div className="space-y-4">
          <h3 className="text-caption text-muted uppercase tracking-wider">
            Systems Deployed
          </h3>
          <ul className="space-y-2">
            {project.systemsDeployed.map((item, index) => (
              <li key={index} className="flex items-start gap-3">
                <span className="text-foreground text-small mt-1">+</span>
                <span className="text-body">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Outcomes */}
        <div className="space-y-4">
          <h3 className="text-caption text-muted uppercase tracking-wider">
            Outcomes
          </h3>
          <div className="grid gap-4 sm:grid-cols-2">
            {project.outcomes.map((outcome, index) => (
              <div
                key={index}
                className="bg-secondary border border-border p-4 space-y-2"
              >
                <p className="text-small text-muted">{outcome.metric}</p>
                {outcome.before && outcome.after ? (
                  <p className="text-body font-mono">
                    <span className="text-muted">{outcome.before}</span>
                    <span className="text-muted mx-2">→</span>
                    <span className="text-foreground">{outcome.after}</span>
                  </p>
                ) : outcome.change ? (
                  <p className="text-body font-mono text-foreground">
                    {outcome.change}
                  </p>
                ) : (
                  <p className="text-body text-foreground">{outcome.note}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}

export function Projects() {
  return (
    <Layout>
      {/* Header */}
      <section className="section border-b border-border">
        <div className="container-narrow">
          <div className="space-y-6">
            <h1 className="text-display-sm md:text-display">Systems Operated</h1>
            <p className="text-body text-subtle max-w-lg">
              We do not display client logos. We do not publish testimonials.
              Below are operational systems we have deployed.
            </p>
          </div>
        </div>
      </section>

      {/* Projects List */}
      <section className="section">
        <div className="container-narrow">
          {projects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </section>
    </Layout>
  );
}

export default Projects;
